import { signal, batch, computed } from '@preact/signals-react'
import { slaveId, userData } from '@signals/user'
import { offices, officesPickoff, sites, rentalDates, rentalLength, startHour, endHour, currency } from '@signals'
import { formatDate, HeatColor } from '@ui-seeker/utils'

export const isSearching = signal(false)
export const idSearch = signal(null)
export const userComesFromUrl = signal(false)
export const realTimeTasks = signal({})
export const popoverData = signal([])
export const tableColorsSuccessRange = signal(new HeatColor({ min: 0, max: 1, maxLightness: 0.7 }))
export const tableColorsMediumRange = signal(new HeatColor({ min: 0, max: 1, maxLightness: 0.7 }))
export const tableColorsErrorRange = signal(new HeatColor({ min: 0, max: 1, maxLightness: 0.7 }))


export const clearSignals = () => batch(() => {
	isSearching.value = false
	idSearch.value = null
	userComesFromUrl.value = false
	realTimeTasks.value = {}
	popoverData.value = []
})


export const realTimeFilters = computed(() => ({
	uid: slaveId.value || userData.value.uid,
	id_office_pickup: offices.value,
	id_office_dropoff: officesPickoff.value,
	id_site: sites.value,
	date_from: rentalDates.value.map(a => formatDate(a, { format: 'yyyy-MM-dd' })),
	lor: rentalLength.value.map(Number),
	time_from: formatDate(startHour.value, { format: 'HH:mm' }),
	time_to: formatDate(endHour.value, { format: 'HH:mm' }),
	id_currency: currency.value
}))